import { render, staticRenderFns } from "./idfcComment.vue?vue&type=template&id=17b54476&"
import script from "./idfcComment.vue?vue&type=script&lang=js&"
export * from "./idfcComment.vue?vue&type=script&lang=js&"
import style0 from "./idfcComment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports